import React, { Fragment } from "react";
import SignedInNavbarImproved from "../../SignedInNavbarImproved";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import Container from "../my_container/Container";
import { Tab } from "@headlessui/react";

const allHistories = [
  { date: "31 January 2023", orderNumber: "12345678960", total: "N 23,000.00", status: "Under Review" },
  { date: "31 January 2023", orderNumber: "12345678960", total: "N 23,000.00", status: "Returns Approved" },
  { date: "31 January 2023", orderNumber: "12345678960", total: "N 23,000.00", status: "Replacement shipped" },
  { date: "31 January 2023", orderNumber: "12345678960", total: "N 23,000.00", status: "Completed" },
  { date: "31 January 2023", orderNumber: "12345678960", total: "N 23,000.00", status: "Completed" },
  { date: "31 January 2023", orderNumber: "12345678960", total: "N 23,000.00", status: "Closed" },
  { date: "31 January 2023", orderNumber: "12345678960", total: "N 23,000.00", status: "Completed" },
];

const ReturnsHistoryPage = () => {
  const navigate = useNavigate();

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  // 🔹 Status color mapping
  const getStatusClass = (status) => {
    switch (status) {
      case "Under Review":
        return "text-[#EFA92B]";
      case "Returns Approved":
        return "text-[#EFA92B]";
      case "Replacement shipped":
        return "text-[#EFA92B]";
      case "Completed":
        return "text-[#69913D]";
      case "Closed":
        return "text-[#69913D]";
      default:
        return "text-gray-500";
    }
  };

  // 🔹 Render filtered histories
  const renderHistories = (filterStatus) => {
    const filtered =
      filterStatus === "All"
        ? allHistories
        : allHistories.filter((h) => h.status === filterStatus);

    if (filtered.length === 0) {
      return <div className="text-gray-500 text-sm">No records found.</div>;
    }

    return (
      <div className="space-y-4 @container">
        {filtered.map((history, index) => (
          <div key={index}  onClick={() => navigate("/returns-policy/request-status")} className="">
            <span className="pl-2 text-xs font-medium text-gray-700">{history.date}</span>
            <div  onClick={() => navigate("#")} className="mt-[2px] px-4 py-3 border border-gray-200 rounded-md bg-[#F9F9F9] hover:shadow cursor-pointer transition duration-300">
                <div className="flex flex-col @xs:flex-row @xs:justify-between text-sm">
                    <div className="text-sm font-semibold text-gray-700">
                        <span className="font-normal">Order Number:</span> {history.orderNumber}
                    </div>
                    <span className={`${getStatusClass(history.status)} font-medium text-sm`}>
                        {history.status}
                    </span>
                </div>
                <div className="mt-1 text-sm text-gray-600 font-bold">{history.total}</div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const tabs = [
    { name: "All Returns", filter: "All" },
    { name: "Returns Approved", filter: "Returns Approved" },
    { name: "Replacement Shipped", filter: "Replacement shipped" },
    { name: "Completed", filter: "Completed" },
    { name: "Closed", filter: "Closed" },
  ];

  return (
    <>
      <SignedInNavbarImproved />
      <div className="min-h-screen bg-white text-gray-800 @container">
        <Container className="pt-8 pb-20">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center space-x-2 sm:space-x-4">
              <div
                onClick={() => navigate(-1)}
                className="rounded-full p-1 hover:bg-gray-200"
              >
                <BiArrowBack className="h-6 w-6 cursor-pointer text-gray-600" />
              </div>
              <div className="text-lg font-bold text-gray-700 sm:text-2xl">
                Returns History
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="w-full">
            <Tab.Group>
              <Tab.List className="flex border-b border-gray-200 flex-wrap gap-2">
                {tabs.map((tab) => (
                  <Tab as={Fragment} key={tab.name}>
                    {({ selected }) => (
                      <button
                        className={classNames(
                          "px-4 py-2 text-sm font-medium border-b-2 -mb-px focus:outline-none",
                          selected
                            ? "border-[#558223] text-[#558223]"
                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        )}
                      >
                        {tab.name}
                      </button>
                    )}
                  </Tab>
                ))}
              </Tab.List>

              <Tab.Panels className="mt-4">
                {tabs.map((tab, idx) => (
                  <Tab.Panel key={idx} className="p-2">
                    {renderHistories(tab.filter)}
                  </Tab.Panel>
                ))}
              </Tab.Panels>
            </Tab.Group>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ReturnsHistoryPage;

